export class InternalReportsApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get internal report
     * @returns any
     * @throws ApiError
     */
    get({ frequency = 'monthly', }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/internal-reports',
            query: {
                'frequency': frequency,
            },
        });
    }
}
